import { all } from 'redux-saga/effects';
import { filesSaga } from './filesSaga';
import { reportsSaga } from './reportsSaga';
import { fetchFileTransferDetailsSaga } from './filesTransferDetailsSaga';
import { userManagementSaga } from './userManagementSaga';
import { vendorSaga } from './vendorSaga';
import { workspaceSaga } from './workspaceSaga';
import { costMaintenanceSaga } from './costMaintenanceSaga';
import { enterpriseCostSaga } from './enterpriseCostSaga';
import { agreementSaga } from './agreementSaga';
import { utilitiesSaga } from './utilitiesSaga';
import { massItemUploadSaga } from './massItemUploadSaga';
import { searchDataSaga } from './searchDataSaga';
import { costImpactTermsSaga } from './costImpactTermsSaga';
import { formulaGroupSaga } from './formulaGroupSaga';
import { costViewSaga } from './costViewSaga';
import { segmentDataSaga } from './segmentDataSaga';

function* rootSaga() {
  yield all([
    filesSaga(),
    fetchFileTransferDetailsSaga(),
    reportsSaga(),
    userManagementSaga(),
    vendorSaga(),
    workspaceSaga(),
    enterpriseCostSaga(),
    agreementSaga(),
    costMaintenanceSaga(),
    utilitiesSaga(),
    massItemUploadSaga(),
    searchDataSaga(),
    costImpactTermsSaga(),
    formulaGroupSaga(),
    costViewSaga(),
    segmentDataSaga(),
  ]);
}

export default rootSaga;
